<template>
  <div class="subscriptionUpsellCard">
    <div class="subscriptionUpsellCard__header">
      <HusleieLogo />
    </div>
    <div class="subscriptionUpsellCard__content">
      <div>
        <div class="subscriptionUpsellCard__content__header">
          <i class="h4 budicon-house" />
          <h5>{{ header }}</h5>
        </div>
        <p class="mt-1">
          {{ text }}
        </p>

        <div class="subscriptionUpsellCard__content__leftBenefits">
          <div>
            <span class="mt-1">
              <i class="h4 budicon-check-ui text-primary" />
            </span>
            <span>Ingen oppsigelsestid</span>
          </div>
          <div>
            <span class="mt-1">
              <i class="h4 budicon-check-ui text-primary" />
            </span>
            <span>3 mnd fornøydgaranti</span>
          </div>
          <div>
            <span class="mt-1">
              <i class="h4 budicon-check-ui text-primary" />
            </span>
            <span>Ingen oppstartsgebyr</span>
          </div>
          <div
            v-for="(benefit, index) in benefits"
            :key="index"
            class="subscriptionUpsellCard__content__leftBenefits__hide"
          >
            <span class="mt-1">
              <i class="h4 budicon-check-ui text-primary" />
            </span>
            <span>{{ benefit }}</span>
          </div>
        </div>

        <div class="subscriptionUpsellCard__content__buttons -primary">
          <template v-if="!subscriptionPlanName">
            <button class="btn btn-sm btn-primary" @click="$emit('input', 'Premium')">
              {{ translationButton1 }}
            </button>
            <button class="btn btn-sm btn-secondary" @click="$emit('input', 'Basic')">
              {{ translationButton2 }}
            </button>
          </template>
          <template v-else-if="subscriptionPlanName === 'Basic'">
            <button class="btn btn-sm btn-primary" @click="$emit('input', 'Premium')">
              {{ translationButton1 }}
            </button>
            <a href="https://www.husleie.no/utleier/forvaltning-abo/" class="btn btn-sm btn-secondary" target="_blank">
              {{ translationButton2 }}
            </a>
          </template>
        </div>
      </div>

      <div>
        <div class="subscriptionUpsellCard__content__rightBenefits">
          <div class="subscriptionUpsellCard__content__rightBenefits__benefits">
            <div v-for="(benefit, index) in benefits" :key="index">
              <span class="mt-1">
                <i class="h4 budicon-check-ui text-primary" />
              </span>
              <span>{{ benefit }}</span>
            </div>
          </div>
          <span class="subscriptionUpsellCard__content__rightBenefits__readMore">
            <a href="https://www.husleie.no/utleier/forvaltning-abo/" target="_blank"> Les mer </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import HusleieLogo from '@/components/HusleieLogo.vue';

export default Vue.extend({
  name: 'SubscriptionUpsellCard',
  components: {
    HusleieLogo,
  },
  props: {
    header: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    subscriptionPlanName: {
      type: String,
      required: true,
    },
    translationButton1: {
      type: String,
      required: true,
    },
    translationButton2: {
      type: String,
      required: true,
    },
    benefits: {
      type: Array,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.subscriptionUpsellCard {
  border: 1px solid $gray-200;
  background-color: rgb(236, 248, 242);
  padding: 2rem 1.5rem;
  border-radius: 12px;
}
.subscriptionUpsellCard__header {
  display: flex;
  justify-content: center;
}
.subscriptionUpsellCard__content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem 4rem;
  margin-top: 2rem;
}
.subscriptionUpsellCard__content__header {
  display: flex;
  column-gap: 1.5rem;
  align-items: center;
}
.subscriptionUpsellCard__content__leftBenefits {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.subscriptionUpsellCard__content__leftBenefits div {
  display: flex;
  gap: 0rem 0.2rem;
  align-items: center;
}
.subscriptionUpsellCard__content__rightBenefits {
  display: none;
}
.subscriptionUpsellCard__content__buttons {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem 0rem;
  margin-top: 1rem;
}

@media (min-width: 600px) {
  .subscriptionUpsellCard__content__leftBenefits {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
  .subscriptionUpsellCard__content__buttons {
    display: flex;
    flex-direction: row;
    gap: 0rem 0.5rem;
  }
}

@media (min-width: 1200px) {
  .subscriptionUpsellCard__content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 1rem;
    margin-top: 2rem;
  }
  .subscriptionUpsellCard__content__leftBenefits {
    display: flex;
    flex-direction: row;
    gap: 0rem 0.5rem;
  }
  .subscriptionUpsellCard__content__leftBenefits__hide {
    display: none !important;
  }
  .subscriptionUpsellCard__content__rightBenefits {
    display: block;
    background: white;
    border: 1px solid $gray-200;
    margin-top: 2rem;
    padding: 1rem;
  }
  .subscriptionUpsellCard__content__rightBenefits__benefits {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    padding: 1rem;
  }
  .subscriptionUpsellCard__content__rightBenefits__benefits div {
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
  }
  .subscriptionUpsellCard__content__rightBenefits__readMore {
    display: flex;
    justify-content: right;
  }
  .subscriptionUpsellCard__content__rightBenefits__readMore a {
    color: $husleie-blue;
    text-decoration: underline;
  }
}
</style>
